/**
 * Tracks whether the conversation screen is currently visible.
 * Used to hide the WhatsApp FAB so it doesn't overlap the message input.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

interface ChatVisibilityContextType {
  isChatVisible: boolean;
  setChatVisible: (visible: boolean) => void;
}

const ChatVisibilityContext = createContext<ChatVisibilityContextType>({
  isChatVisible: false,
  setChatVisible: () => {},
});

export function ChatVisibilityProvider({ children }: { children: React.ReactNode }) {
  const [isChatVisible, setIsChatVisible] = useState(false);
  const setChatVisible = useCallback((visible: boolean) => setIsChatVisible(visible), []);

  return (
    <ChatVisibilityContext.Provider value={{ isChatVisible, setChatVisible }}>
      {children}
    </ChatVisibilityContext.Provider>
  );
}

export const useChatVisibility = () => useContext(ChatVisibilityContext);
